import React from "react";
import { useLocalStorageAsRef } from "../hooks/useLocalStorage.js";
export function useDataGridExpandedStore(apiRef, name) {
    const [expandedState, setExpandedState] = useLocalStorageAsRef(`msys-expanded-store-${name}`, {});
    const subscribed = React.useRef(false);
    React.useEffect(() => {
        if (apiRef?.current?.subscribeEvent && !subscribed.current) {
            subscribed.current = true;
            apiRef.current.subscribeEvent?.("rowExpansionChange", node => {
                setExpandedState({
                    ...expandedState.current,
                    [node.id]: node.childrenExpanded ?? false,
                });
            });
        }
    }, [
        apiRef,
        apiRef?.current?.subscribeEvent,
        expandedState,
        setExpandedState,
    ]);
    const isGroupExpanded = React.useCallback((node) => expandedState.current[node.id] ?? false, [expandedState]);
    return { isGroupExpanded };
}
//# sourceMappingURL=useDataGridExpandedStore.js.map